/**  */

// eslint-disable-next-line
import React from 'react';
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';

import { bp } from '../../../config/breakpoints';

const cssTagWrapper = css`
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  min-width: 150px;
  position: absolute;
  bottom: 45px;
  left: 20px;
  line-height: 40px;

  @media (min-width: ${bp.mn_md}) {
    flex-direction: row;
  }

  @media (min-width: ${bp.mn_xl}) {
    bottom: 55px;
    left: 60px;
  }

  li {
    margin-right: 5px;

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

const TagsList = ({ children }) => <ul css={cssTagWrapper}>{children}</ul>;

TagsList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TagsList;
